import { logoutUser } from "../redux-toolkit/features/auth/authSlice";
import { teardownSocket } from "./socket";

const AUTH_FAILURE_MESSAGES = [
  "Forbidden due to token is corrupted",
  "Unauthorized",
  "Forbidden to refresh token",
];

let sessionExpiredHandled = false;

export const isAuthFailure = (error) => {
  if (!error) return false;
  if (error.status === 401) return true;
  if (error.status === 403) {
    const message = String(error?.data?.message || "");
    return AUTH_FAILURE_MESSAGES.some(
      (authMessage) =>
        message === authMessage || message.includes(authMessage),
    );
  }
  return false;
};

export const handleSessionExpired = async (dispatch) => {
  if (sessionExpiredHandled) return;
  if (
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/login")
  ) {
    return;
  }

  sessionExpiredHandled = true;

  try {
    teardownSocket();
    const { persistor } = await import("../redux-toolkit/store");
    persistor.pause();
    dispatch(logoutUser());
    await persistor.purge();
  } catch {
    // Still redirect even if local cleanup fails.
  }

  if (typeof window !== "undefined") {
    window.location.assign("/login");
  }
};
